import React from "react";

type VisualErActiveCard = "extraction" | "mapping" | "rendering" | null;

const MERMAID_SOURCE = `erDiagram

  %% -----------------------

  %% Inputs / Assets (served routes)

  %% -----------------------

  MusicFile {

    string url "/music/<name>.wav"

  }

  NumbersPatternJsonFile {

    string url "/data/unweaving_pattern_41.json"

    string source_path "src/module/numbers/unweaving_pattern_41.json"

  }

  %% -----------------------

  %% Core engine config

  %% -----------------------

  PresetId {

    string value "\\"2-56\\"|\\"grid\\"|\\"melt\\"|\\"square\\"|\\"numbers\\""

  }

  ProcessManagerConfig {

    string presetId

    string[] presetIds

    VisualPreset preset

    AudioAnalyserConfig audio

    LogicConfig logic

    RenderConfig canvas

    Effect256RenderConfig effect256Render

    GridConfig grid

    MeltConfig melt

    SquareConfig square

    NumbersConfig numbers

  }

  %% -----------------------

  %% Preset / Effect model

  %% -----------------------

  VisualPreset {

    string id

  }

  DrawLayerEntry {

    string effectId

    int layer

    string blend "GlobalCompositeOperation"

    float opacity "0..1"

  }

  PostEntry {

    string effectId

  }

  DrawEffect {

    string id

  }

  PostEffect {

    string id

  }

  EffectState {

    string effectId "key (EffectId)"

    any state "module-specific"

  }

  %% -----------------------

  %% Runtime pipeline

  %% -----------------------

  ProcessManager {

    string raf "requestAnimationFrame loop"

  }

  PresetRuntime {

    float time "seconds since start"

    bool recordingOpaque

  }

  PresetRenderer {

    string layerCanvases "Map<EffectId, canvas>"

    string frameA

    string frameB

  }

  RenderService {

    float renderScale "1..4"

    bool recordingOpaque

  }

  RenderConfig {

    bool useDevicePixelRatio

  }

  Viewport {

    int width

    int height

    float dpr

  }

  %% -----------------------

  %% Audio analysis model

  %% -----------------------

  AudioAnalyser {

    string state "AudioSourceState"

  }

  AudioAnalyserConfig {

    int fftSize

    float analyserSmoothingTimeConstant

    float bandSmoothing

    float minDecibels

    float maxDecibels

    bool connectToDestination

    float gain

  }

  AudioSourceState {

    string value "\\"idle\\"|\\"loaded\\"|\\"playing\\"|\\"stopped\\""

  }

  BandEnergies {

    float low

    float midLow

    float midHigh

    float high

  }

  NoiseMetrics {

    float brightness

    float flatness

    float noisiness

  }

  AudioPlaybackInfo {

    string state "AudioSourceState"

    float playbackSeconds

    float durationSeconds

  }

  %% -----------------------

  %% Shared logic model

  %% -----------------------

  LogicConfig {

    float sensitivity

  }

  ResolvedLogicConfig {

    float sensitivity

  }

  ParticlePool {

    int capacity

  }

  RingDotSet {

    int count

  }

  CenterDotSet {

    int count

  }

  %% -----------------------

  %% Modules: 2-56

  %% -----------------------

  Effect256Config {

    LogicConfig logic

    Effect256RenderConfig render

  }

  Effect256RenderConfig {

    bool excludeRingInteriorFromClear

    bool transparentRingHole

    bool renderRingDots

    bool renderCenterDots

  }

  Effect256State {

    float time

    int phase "0|1|2"

  }

  %% -----------------------

  %% Modules: grid

  %% -----------------------

  GridConfig {

    int tileSizePx

  }

  ResolvedGridConfig {

    int tileSizePx

  }

  GridState {

    float time

    float high

  }

  %% -----------------------

  %% Modules: melt

  %% -----------------------

  MeltConfig {

    bool drawLine

    int maxAliveParticles

  }

  ResolvedMeltConfig {

    bool drawLine

    int maxAliveParticles

  }

  MeltLineSet {

    float bornAt

    float theta

    float strength

  }

  MeltState {

    float time

  }

  %% -----------------------

  %% Modules: square

  %% -----------------------

  SquareConfig {

    string shapeMode "\\"normal\\"|\\"kakuhen\\""

    bool proliferationEnabled

  }

  ResolvedSquareConfig {

    string shapeMode

    bool proliferationEnabled

  }

  SquareLineSet {

    float bornAt

    float theta

    float strength

  }

  SquareState {

    float time

  }

  %% -----------------------

  %% Modules: numbers

  %% -----------------------

  MicrotoneKey {

    string key "p00..p40 (41 keys)"

  }

  NumbersPatternJson {

    int bars

    int steps_per_bar

  }

  NumbersConfig {

    string dataUrl

    float scrollPxPerSec

  }

  ResolvedNumbersConfig {

    string dataUrl

    float scrollPxPerSec

  }

  NumbersState {

    float time

    string audioState "AudioSourceState"

    int currentStepIndex

  }

  %% -----------------------

  %% Relationships

  %% -----------------------

  ProcessManagerConfig }o--|| VisualPreset : "resolveProcessManagerConfig()で確定"

  PresetId ||--o{ ProcessManagerConfig : "presetId/presetIds"

  VisualPreset ||--|{ DrawLayerEntry : "draw[]"

  DrawEffect   ||--o{ DrawLayerEntry : "effect"

  VisualPreset ||--o{ PostEntry : "post[]"

  PostEffect   ||--o{ PostEntry : "effect"

  ProcessManager ||--|| AudioAnalyser  : "bands/noise/audio取得"

  ProcessManager ||--|| RenderService  : "viewport/描画"

  ProcessManager ||--|| PresetRuntime  : "state管理 + update"

  ProcessManager ||--|| PresetRenderer : "layer合成 + post"

  RenderService ||--|| Viewport : "resizeToDisplaySize()"

  RenderService ||--|| RenderConfig : "useDevicePixelRatio"

  PresetRuntime ||--|| VisualPreset : "現在のpreset"

  PresetRuntime ||--o{ EffectState : "Map<EffectId,state>"

  DrawEffect ||--o{ EffectState : "idで紐付け"

  PostEffect ||--o{ EffectState : "idで紐付け"

  AudioAnalyser ||--|| AudioAnalyserConfig : "FFT/平滑化/帯域設定"

  AudioAnalyser ||--|| BandEnergies : "sampleBands()"

  AudioAnalyser ||--|| NoiseMetrics : "sampleNoiseMetrics()"

  AudioAnalyser ||--|| AudioPlaybackInfo : "getPlaybackInfo()"

  AudioPlaybackInfo }o--|| AudioSourceState : "state"

  MusicFile ||--o{ AudioAnalyser : "loadFromUrl(url)"

  NumbersPatternJsonFile ||--|| NumbersPatternJson : "fetchしてJSON parse"

  NumbersPatternJson ||--o{ MicrotoneKey : "tracksのキー(p00..p40)"

  NumbersPatternJson ||--|| NumbersState : "normalizeTracksでstateへ"

  MicrotoneKey ||--o{ NumbersState : "tracks: Record<MicrotoneKey,Uint8Array>"

  Effect256Config }o--|| LogicConfig : "共有ロジック設定"

  Effect256State }o--|| ResolvedLogicConfig : "解決済みconfig"

  Effect256State }o--|| ParticlePool : "particles"

  Effect256State }o--|| RingDotSet : "ringDots"

  Effect256State }o--|| CenterDotSet : "centerDots"

  GridConfig ||--|| ResolvedGridConfig : "resolveGridConfig()"

  GridState  }o--|| ResolvedGridConfig : "cfg"

  GridState  }o--|| Viewport : "viewport"

  MeltConfig ||--|| ResolvedMeltConfig : "resolveMeltConfig()"

  MeltState  }o--|| ResolvedMeltConfig : "cfg"

  MeltState  }o--o| MeltLineSet : "lineSet"

  MeltState  }o--|| Viewport : "viewport"

  MeltState  }o--|| ParticlePool : "particles"

  SquareConfig ||--|| ResolvedSquareConfig : "resolveSquareConfig()"

  SquareState  }o--|| ResolvedSquareConfig : "cfg"

  SquareState  }o--o| SquareLineSet : "lineSet"

  SquareState  }o--|| Viewport : "viewport"

  SquareState  }o--|| ParticlePool : "particles"

  NumbersConfig ||--|| ResolvedNumbersConfig : "resolveNumbersConfig()"

  NumbersState  }o--|| ResolvedNumbersConfig : "cfg"

  NumbersState  }o--|| Viewport : "viewport"`;

export const VisualER: React.FC<{
  activeCard?: VisualErActiveCard;
  onCardSelect?: (card: Exclude<VisualErActiveCard, null>) => void;
}> = ({ activeCard = null, onCardSelect }) => {
  const isExtraction = activeCard === "extraction";
  const isMapping = activeCard === "mapping";
  const isRendering = activeCard === "rendering";

  const makeCardInteractivity = (
    card: Exclude<VisualErActiveCard, null>
  ): React.HTMLAttributes<HTMLDivElement> => {
    if (!onCardSelect) return {};
    return {
      role: "button",
      tabIndex: 0,
      onClick: () => onCardSelect(card),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onCardSelect(card);
        }
      },
    };
  };

  return (
    <div className="visual-er">
      <div className="visual-er-toolbar">
        <div className="visual-er-hint">Data Architecture (abstracted)</div>
      </div>

      <div className="visual-er-flow">
        <div className="visual-flow-vertical">
          <div className={`json-card visual-flow-card ${isExtraction ? "is-active" : ""}`}>
            <div className="visual-flow-title">Input</div>
            <div className="json-content">{`{
  "assets": ["MusicFile", "NumbersPatternJsonFile"],
  "config": "ProcessManagerConfig"
}`}</div>
          </div>

          <div className="visual-flow-connector-vertical" aria-hidden="true">
            <svg width="100%" height="56" viewBox="0 0 100 56" preserveAspectRatio="none">
              <path
                d="M50,0 L50,56"
                fill="none"
                stroke="#333"
                strokeWidth="1.5"
                className="visual-flow-path"
              />
            </svg>
          </div>

          <div
            className={`json-card visual-flow-card ${onCardSelect ? "is-tappable" : ""} ${isExtraction ? "is-active" : ""}`}
            id="v-card-extraction"
            aria-label="Extraction Layer"
            {...makeCardInteractivity("extraction")}
          >
            <div className="visual-flow-title">Extraction Layer</div>
            <div className="json-content">{`{
  "audio": ["AudioPlaybackInfo", "BandEnergies", "NoiseMetrics"],
  "numbers": "NumbersState"
}`}</div>
          </div>

          <div className="visual-flow-connector-vertical" aria-hidden="true">
            <svg width="100%" height="56" viewBox="0 0 100 56" preserveAspectRatio="none">
              <path
                d="M50,0 L50,56"
                fill="none"
                stroke="#333"
                strokeWidth="1.5"
                className="visual-flow-path"
              />
            </svg>
          </div>

          <div
            className={`json-card visual-flow-card ${onCardSelect ? "is-tappable" : ""} ${isMapping ? "is-active" : ""}`}
            id="v-card-mapping"
            aria-label="Logic Mapping Layer"
            {...makeCardInteractivity("mapping")}
          >
            <div className="visual-flow-title">Logic Mapping Layer</div>
            <div className="json-content">{`{
  "resolvedConfig": "Resolved*Config",
  "preset": "VisualPreset",
  "effectState": "Map<EffectId, state>"
}`}</div>
          </div>

          <div className="visual-flow-connector-vertical" aria-hidden="true">
            <svg width="100%" height="56" viewBox="0 0 100 56" preserveAspectRatio="none">
              <path
                d="M50,0 L50,56"
                fill="none"
                stroke="#333"
                strokeWidth="1.5"
                className="visual-flow-path"
              />
            </svg>
          </div>

          <div
            className={`json-card visual-flow-card ${onCardSelect ? "is-tappable" : ""} ${isRendering ? "is-active" : ""}`}
            id="v-card-rendering"
            aria-label="Rendering Layer"
            {...makeCardInteractivity("rendering")}
          >
            <div className="visual-flow-title">Rendering Layer</div>
            <div className="json-content">{`{
  "viewport": "Viewport",
  "runtime": "PresetRuntime",
  "renderer": "PresetRenderer"
}`}</div>
          </div>
        </div>
      </div>
    </div>
  );
};


